export const isEmptyValue = (value: any): boolean => {
  if (Array.isArray(value)) return value.length === 0;
  return !value;
};
